import { THttpErrorResp } from '../utils/fetch/index.types';
import { setAppReset, setIsLoggedIn } from '../redux/app/actions';
import storeInit from '../redux/store';
import { toastAuthError, toastNetError } from '../utils/toast-msgs';
const { store } = storeInit;

const parseHttpErrors = (parsedBody: THttpErrorResp) => {
    let msg: string =
        parsedBody.message ||
        'Network connection error. Please try again later';

    if (msg === 'Network timeout reached') {
        toastNetError(parsedBody.message);
        return parsedBody.message;
    }

    if (parsedBody.code === undefined) return msg;
    // debugger;
    switch (parsedBody.code) {
        case 0:
            switch (parsedBody.message) {
                case 'something went wrong':
                default:
                    toastNetError(msg);
                    return msg;
            }
        case 3:
        case 9:
            msg = 'Access token is expired. Please re-login';
            window.localStorage.clear();
            toastAuthError(msg);
            setIsLoggedIn(false);
            store.dispatch(setAppReset());
            return msg;
        default:
            return msg;
    }
};

export default parseHttpErrors;
